import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["after", "align", "appearance", "before", "className", "density", "isActive", "isDisabled", "isFullWidth", "isLoading", "isSquare", "intent", "label", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "marginX", "marginY", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "paddingX", "paddingY", "shape", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { Intent, intentClass, ControlDensityType, ControlSizeType, ControlShapeType, ControlAppearanceType, controlClasses } from '../../../library';
import { flexClasses } from '../../../utilities';
import { Loader } from '../../loader';
import { inputClasses } from '../../form';
import { ButtonGroupContext } from './button-group';
import { useSpacingProps } from '../../../library/src/use-spacing-props';
export var buttonClasses = {
  BUTTON: 'button',
  GROUP: 'buttons'
};
export var Button = React.forwardRef(function (props, ref) {
  var defaultProps = {
    appearance: ControlAppearanceType.FILL,
    density: ControlDensityType.NORMAL,
    isDisabled: false,
    shape: ControlShapeType.ROUNDED,
    size: ControlSizeType.MEDIUM
  };
  var groupProps = React.useContext(ButtonGroupContext);
  var mergedProps = _objectSpread(_objectSpread(_objectSpread({}, defaultProps), groupProps), props);
  var after = mergedProps.after,
    align = mergedProps.align,
    appearance = mergedProps.appearance,
    before = mergedProps.before,
    className = mergedProps.className,
    density = mergedProps.density,
    isActive = mergedProps.isActive,
    isDisabled = mergedProps.isDisabled,
    isFullWidth = mergedProps.isFullWidth,
    isLoading = mergedProps.isLoading,
    isSquare = mergedProps.isSquare,
    intent = mergedProps.intent,
    label = mergedProps.label,
    margin = mergedProps.margin,
    marginBottom = mergedProps.marginBottom,
    marginLeft = mergedProps.marginLeft,
    marginRight = mergedProps.marginRight,
    marginTop = mergedProps.marginTop,
    marginX = mergedProps.marginX,
    marginY = mergedProps.marginY,
    padding = mergedProps.padding,
    paddingBottom = mergedProps.paddingBottom,
    paddingLeft = mergedProps.paddingLeft,
    paddingRight = mergedProps.paddingRight,
    paddingTop = mergedProps.paddingTop,
    paddingX = mergedProps.paddingX,
    paddingY = mergedProps.paddingY,
    shape = mergedProps.shape,
    size = mergedProps.size,
    htmlProps = _objectWithoutProperties(mergedProps, _excluded);
  var _useSpacingProps = useSpacingProps(props),
    paddingClasses = _useSpacingProps.paddingClasses,
    marginClasses = _useSpacingProps.marginClasses;
  var classNames = cn(buttonClasses.BUTTON, intentClass(intent), controlClasses({
    size: size,
    density: density,
    appearance: appearance,
    shape: shape
  }), {
    '-loading': isLoading,
    '-disabled': isDisabled || isLoading,
    '-fullwidth': isFullWidth,
    '-active': isActive,
    '-square': isSquare
  }, paddingClasses, marginClasses, className);
  var textClassNames = cn('control__text', _defineProperty(_defineProperty({}, flexClasses.justify.start, align === 'left'), flexClasses.justify.end, align === 'right'));
  var renderAttachment = function renderAttachment(content) {
    return React.createElement("div", {
      className: inputClasses.ADDON
    }, " ", content, " ");
  };
  var renderChildren = function renderChildren() {
    return React.createElement(React.Fragment, null, React.Children.count(props.children) > 0 ? props.children : label);
  };
  var renderLoading = function renderLoading() {
    return React.createElement("span", {
      className: "button__loader"
    }, React.createElement(Loader, {
      count: 3,
      delay: 0
    }));
  };
  return React.createElement("button", _extends({
    className: classNames,
    disabled: isDisabled || isLoading,
    ref: ref
  }, htmlProps), before ? renderAttachment(before) : null, React.createElement("span", {
    className: textClassNames
  }, renderChildren()), isLoading ? renderLoading() : null, after ? renderAttachment(after) : null);
});
Button.displayName = 'Button';
Button.defaultProps = {
  intent: Intent.NONE,
  isActive: false,
  isLoading: false,
  type: 'button'
};